import { observer } from "mobx-react-lite"
import React, { FC, useCallback, useEffect, useState } from "react"
import { Appearance, ViewStyle } from "react-native"
import { JalaLoading, Screen } from "../../../components"
// import { useStores } from "../../models"
import { CompositeScreenProps, useFocusEffect } from "@react-navigation/native"
import { CONSTANTS, JSHmac } from "react-native-hash"
import { useStores } from "../../../models"
import { goBack } from "../../../navigators"
import { color } from "../../../theme"
import config from "../../../utils/config"
import I18n from "i18n-js"
import { View } from "native-base"
import JalaAnalytic from "../../../utils/jala-analytic"
import { delay } from "../../../utils/delay"
import { useIntercom } from "react-use-intercom"

const ROOT: ViewStyle = {
  flexGrow: 1,
}

export const HelpScreen: FC<{ colorScheme: "light" | "dark" } & CompositeScreenProps<any, any>> = observer(function HelpScreen(props) {
  const { colorScheme = "light" || Appearance.getColorScheme() } = props

  // Pull in one of our MST stores
  const { userStore: { user } } = useStores();
  const [ booted, setBooted ] = useState<boolean>(false);
  const [ loading, setLoading ] = useState<boolean>(true)

  const { boot, shutdown, show } = useIntercom()

  useEffect(() => {
    if (!user) {
      shutdown();
      goBack('App.Stack');
      return;
    }
    const { INTERCOM_SECRET_KEY_WEB } = config();

    JalaAnalytic.log('Mobile app: navigation - intercom');

    setLoading(true);
    JSHmac(`${user.id}`, INTERCOM_SECRET_KEY_WEB, CONSTANTS.HmacAlgorithms.HmacSHA256)
      .then(async (hmac) => {
        console.log(hmac);
        boot({
          userId: `${user.id}`,
          name: user.name,
          email: user.email,
          phone: user.phone,
          customAttributes: { createdAt: user.created_at },
          languageOverride: user.settings?.locale || I18n.locale,
          hideDefaultLauncher: true,
          userHash: hmac
        });
        setBooted(true);
        await delay(100);
        show();
      }).finally(() => {
        setLoading(false);
        goBack('App.Stack');
      });
  }, [boot, show, shutdown, user])

  useFocusEffect(useCallback(() => {
    if (booted) {
      setLoading(true);
      JalaAnalytic.log('Mobile app: navigation - intercom');
      show()
      delay(100)
        .then(() => {
          setLoading(false);
          goBack('App.Stack');
        });
    }
  }, [booted, show]))

  return (
    <Screen
      style={ROOT}
      preset="scroll"
      colorScheme={colorScheme}
      backgroundBar={colorScheme === "light" ? color.primary : undefined}
      statusBar={colorScheme === "light" ? "light-content" : "dark-content"}
    >
      {loading && <View flex={1} alignItems="center" justifyContent="center">
        <JalaLoading />
      </View>}
    </Screen>
  );
})
